@if (isVisible) {
<div style="height: auto; width: auto">
  <csxwc-tos-imod-operations-info
    [isVisible]="isVisible"
    [terminalCode]="terminalCode"
    [iohEquipmentInfo]="iohEquipmentInfo()"
    (isVisibleChange)="onClose($event)"
  ></csxwc-tos-imod-operations-info>
</div>
}
